// TYPES
import { Children } from '@/types/common.types';

// CONSTANTS
import { ROUTE_ROOT } from '@/constants/routes';

// COMPONENTS
import Redirect from '@/components/Redirect';

interface Props {
  component: Children;
  isAuth: boolean;
}

const PrivateRoute = ({ component, isAuth }: Props) => {
  if (!isAuth) {
    return (
      <Redirect
        to={{
          pathname: ROUTE_ROOT,
          state: { from: '' },
        }}
      />
    );
  }

  return <>{component}</>;
};

export default PrivateRoute;
